<template>
  <div
    v-if="value"
    class="
      overflow-y-auto
      flex
      overflow-x-hidden
      fixed
      top-0
      right-0
      left-0
      z-50
      justify-center
      items-center
      w-full
      md:inset-0
      h-full
      max-h-full
      bg-gray-900
      bg-opacity-80
      backdrop-blur-sm
    "
  >
    <Transition
      name="zoom-in"
      appear
    >
      <div v-if="value" class="relative p-4 w-full max-w-2xl max-h-full">
        <!-- Modal content -->
        <div class="relative bg-white rounded shadow border dark:bg-muted-800 dark:border-muted-700">
          <!-- Modal header -->
          <div class="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-muted-700">
            <slot name="title">
              <h3 class="text-xl font-semibold text-gray-900 dark:text-white !my-0">
                {{ title }}
              </h3>
            </slot>
            <button
              type="button"
              class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
              @click="close"
            >
              <i
                class="w-3 h-3 fas fa-times"
              />
              <span class="sr-only">Close modal</span>
            </button>
          </div>
          <!-- Modal body -->
          <div class="p-4 md:p-5 max-h-[calc(82vh-56px)] overflow-scroll">
            <slot />
          </div>
          <!-- Modal footer -->
          <div class="flex items-center justify-end space-x-2 py-2 px-4 md:px-5 border-t border-gray-200 rounded-b dark:border-muted-700">
            <slot name="actions" :close="close">
              <al-button
                outline
                @click="close"
              >
                Close
              </al-button>
            </slot>
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script>
export default {
  name: 'DialogComponent',
  props: [
    'value',
    'title'
  ],
  watch: {
    value(val) {
      // eslint-disable-next-line no-unused-expressions
      val ? this.$emit('open') : this.$emit('close');
    }
  },
  methods: {
    close() {
      this.$emit('input', false);
    }
  }
};
</script>

<style lang="scss" scoped>
.zoom-in-enter-active, .zoom-in-leave-active {
  transition: opacity .5s;
}
.zoom-in-enter, .zoom-in-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: translateY(30px);
  opacity: 0;
}
</style>
